import Util from "./Util.js";
import { gsap } from "./Util.js";

class Slider extends Util {
  constructor() {
    super();

    this.init();
  }

  init() {
    if (window.website.page === "top") {
      this.fadeSlider();
      this.swiperTopOnlineStore();
      this.swiperOther();
      this.swiperJournal();
    } else if (window.website.page === "business-partner") {
      this.fadeSlider();
      this.swiperWorks();
    } else if (window.website.page === "membership") {
      this.fadeSlider();
    } else if (window.website.page === "about") {
      this.swiperMedia();
    } else if (window.website.page === "stay") {
      this.swiperStay();
    }
  }

  fadeSlider() {
    if (document.querySelector(".slider-fade")) {
      for (const sliderFade of document.querySelectorAll(".slider-fade")) {
        const sliderFadeCell = sliderFade.querySelectorAll(".cell");
        let num = 0,
          interval = null;

        const slideStart = () => {
          interval = setInterval(() => {
            sliderFadeCell.forEach((cell) => {
              cell.classList.remove("current");
            });

            sliderFadeCell[num].classList.add("current");
            num++;

            if (num > sliderFadeCell.length - 1) {
              num = 0;
            }
          }, 8000);
        };

        slideStart();

        sliderFade.addEventListener("mouseenter", () => {
          clearInterval(interval);
        });

        sliderFade.addEventListener("mouseleave", () => {
          slideStart();
        });
      }
    }
  }

  swiperTopOnlineStore() {
    const swiperMainLeftDOM = document.querySelector(".swiper.swiper-left");
    const swiperMainRightDOM = document.querySelector(".swiper.swiper-right");
    const navNext = document.querySelector(".slider-main .swiper-button-next");
    const navPrev = document.querySelector(".slider-main .swiper-button-prev");

    if (this.website.isDesktop) {
      const swiperMainLeft = new Swiper(swiperMainLeftDOM, {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 400,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: true,
        // navigation: {
        //   nextEl: navNext,
        //   prevEl: navPrev,
        // },
        // loop: true,
      });

      const swiperMainRight = new Swiper(swiperMainRightDOM, {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 400,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
        // loop: true,
      });

      swiperMainLeft.controller.control = [swiperMainRight];
      swiperMainRight.controller.control = [swiperMainLeft];
    } else {
      const swiperMainLeft = new Swiper(swiperMainLeftDOM, {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 400,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
        // loop: true,
      });

      const swiperMainRight = new Swiper(swiperMainRightDOM, {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 400,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: true,
        // loop: true,
      });

      swiperMainLeft.controller.control = [swiperMainRight];
      swiperMainRight.controller.control = [swiperMainLeft];
    }
  }

  swiperOther() {
    if (document.querySelector(".swiper.swiper-other")) {
      const swiperOtherDOM = document.querySelector(".swiper.swiper-other");
      const navNext = document.querySelector(".slider-other .swiper-button-next");
      const navPrev = document.querySelector(".slider-other .swiper-button-prev");
      const slidesPerView = this.website.isDesktop ? 5 : 2.24;

      const swiperOther = new Swiper(swiperOtherDOM, {
        spaceBetween: 0,
        slidesPerView: slidesPerView,
        speed: 400,
        allowTouchMove: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
      });
    }
  }

  swiperWorks() {
    if (this.website.isDesktop) {
      if (document.querySelector(".swiper.swiper-works")) {
        const swiperWorksDOM = document.querySelector(".swiper.swiper-works");
        const slidesPerView = this.website.isDesktop ? 5.2 : 2.24;

        const swiperWorks = new Swiper(swiperWorksDOM, {
          spaceBetween: 8,
          slidesPerView: slidesPerView,
          speed: 400,
          allowTouchMove: true,
          // loop: true,
        });
      }
    }
  }

  swiperMedia() {
    if (document.querySelector(".swiper.swiper-media")) {
      const swiperMediaDOM = document.querySelector(".swiper.swiper-media");
      const slidesPerView = this.website.isDesktop ? 4.83 : 2.5;
      const slidesSpaceBetween = this.website.isDesktop ? 50 : 32;

      const swiperMedia = new Swiper(swiperMediaDOM, {
        spaceBetween: slidesSpaceBetween,
        slidesPerView: slidesPerView,
        speed: 400,
        allowTouchMove: true,
        // loop: true,
      });
    }
  }

  swiperStay() {
    if (document.querySelector(".swiper.swiper-stay")) {
      const swiperStayDOM = document.querySelector(".swiper.swiper-stay");
      const slidesPerView = this.website.isDesktop ? 2.4 : 1.44;

      const swiperStay = new Swiper(swiperStayDOM, {
        spaceBetween: 8,
        slidesPerView: slidesPerView,
        speed: 800,
        allowTouchMove: true,
        centeredSlides: true,
        loop: true,
      });
    }
  }

  swiperJournal() {
    if (document.querySelector("#page-top .swiper.swiper-journal")) {
      const swiperJournalDOM = document.querySelector("#page-top .swiper.swiper-journal");
      const slidesPerView = this.website.isDesktop ? 3.83 : 1.44;
      let current = document.querySelector(".swiper-journal-current"),
        total = document.querySelector(".swiper-journal-len");

      // total.textContent = "°" + swiperJournalDOM.querySelectorAll(".swiper-slide").length.toString().padStart(2, "0");

      const swiperJournal = new Swiper(swiperJournalDOM, {
        spaceBetween: 20,
        slidesPerView: slidesPerView,
        speed: 800,
        allowTouchMove: true,
        centeredSlides: true,
        // loop: true,
      });

      // swiperJournal.on("slideChangeTransitionEnd", function (el) {
      //   let numData = swiperJournalDOM.querySelector(".swiper-slide-active").getAttribute("data-swiper-slide-index"),
      //     numString = parseInt(numData);
      //   numString = numString + 1;

      //   const padString = numString.toString().padStart(2, "0");

      //   current.textContent = padString;
      // });
    }
  }
}

export default Slider;
